import { useMemo } from 'react';

import { useGetExternalLoyaltyManualOfferQuery } from '@occc/graphql';

import { ExternalLoyaltyManualOfferDetails } from '../../tobacco-api-offers.types';

export const useTobaccoApiOfferDetails = (id: string | undefined) => {
  const { data, loading, error } = useGetExternalLoyaltyManualOfferQuery({
    variables: { uuid: id ?? '' },
    skip: !id,
  });

  const offer: ExternalLoyaltyManualOfferDetails | undefined = useMemo(
    () => data?.externalLoyaltyManualOffer,
    [data],
  );

  return { offer, loading, error };
};
